import { combineReducers } from "redux";
import { routerReducer } from "react-router-redux";

import auth from "./auth";
import users from "./users";
import vouchers from "./vouchers";
import benefits from "./benefits";
import benefitsTypes from "./benefitsTypes";
import channels from "./channels";
import commercialCampaign from "./commercialCampaign";
import documents from "./documents";
import stores from "./stores";
import payments from "./payments";
import productsTypes from "./productsTypes";
import events from "./events";
import reports from "./reports";
import attendances from "./attendances";
import sections from "./sections";
import kafka from "./kafka";
import groups from "./groups";
import reasons from "./reasons";
import roles from "./roles";
import settings from "./settings";
import campaigns from "./campaigns";
import regions from "./regions";
import prizes from "./prizes";
import multipliers from "./multipliers";
import points from "./points";

export default combineReducers({
  auth,
  users,
  vouchers,
  benefits,
  benefitsTypes,
  channels,
  commercialCampaign,
  documents,
  stores,
  payments,
  productsTypes,
  events,
  reports,
  attendances,
  sections,
  kafka,
  groups,
  reasons,
  roles,
  settings,
  campaigns,
  prizes,
  multipliers,
  regions,
  points,
  router: routerReducer,
});
